module Meevo.Components.Controls.SmartMover {
    import EmployeeCategory = Model.EmployeeCategory;

    export class CSEEmployeeCategoriesCollection extends ReportEmployeeCategoriesCollection implements IApiCollection<EmployeeCategory> {
        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }
    }
}
